export default {"src":"/_next/static/media/logo-hrf.73b8b665.svg","height":90,"width":190,"blurWidth":0,"blurHeight":0};